<template>
    <div class="feature-block-group uk-flex uk-flex-center uk-flex-stretch uk-gap uk-flex-wrap">
        <slot></slot>
    </div>
</template>

<script>
export default {
    data: function () {
        return {};
    }

}
</script>

<style scoped lang="scss">

</style>
